import { css } from '@emotion/css'
import type { CSSObject } from '@emotion/react'
import { DropdownSettingsButton } from 'components/DropdownButtons/DropdownSettingsButton'
import { ExpandableChevronIndicator } from 'components/ExpandableChevronIndicator/ExpandableChevronIndicator'
import { TitleChildrenWrapper } from 'components/SectionTitleBarComponents/TitleChildrenWrapper'
import React from 'react'
import { colors } from 'settings/colors'

const paddingLeftTitleWrapper = 14
const paddingRightTitle = 14
const paddingLeftAndRight = 15

export const SectionTitleBar = ({
  collapsed,
  containerWidth,
  onCollapse,
  sticky = false,
  title,
  titleCss,
  titleToggle,
  titleLink,
  fieldAssetPicker,
  wrapperCss,
}: {
  collapsed: boolean
  containerWidth?: number
  onCollapse: (changingFromOpenToCollapsed: boolean) => void
  sticky?: boolean
  title: React.ReactNode
  titleCss?: CSSObject
  titleToggle?: React.ReactNode
  titleLink?: React.ReactNode[]
  fieldAssetPicker?: React.ReactNode
  wrapperCss?: CSSObject
}) => {
  return (
    <div
      className={css([
        {
          backgroundColor: colors.grey200,
          borderBottom: `1px solid ${collapsed ? '#cccbcb' : 'transparent'}`,
          fontWeight: 'bold',
          touchAction: 'pan-y',
          userSelect: 'none',
          width: '100%',
          ...wrapperCss,
        },
      ])}
    >
      <div
        css={{
          backgroundColor: colors.grey200,
          boxSizing: 'border-box',
          padding: `6px ${paddingLeftAndRight}px`,
          display: 'flex',
          justifyItems: 'center',
          alignItems: 'center',
          flex: 1,
          maxWidth: containerWidth,
          position: sticky ? 'sticky' : 'relative',
          left: sticky ? 0 : undefined,
          top: sticky ? 0 : undefined,
        }}
      >
        <span
          css={{
            /**
             * we can give it a bigger area to target for our onClick
             * without taking up more space via a transparent border
             */
            border: '12px solid transparent',
            boxSizing: 'border-box',
          }}
        >
          <ExpandableChevronIndicator expanded={!collapsed} onClick={() => onCollapse(!collapsed)} />
        </span>
        <div
          className={css({
            paddingLeft: paddingLeftTitleWrapper,
            paddingTop: collapsed ? 6.8 : 0,
            paddingBottom: collapsed ? 6.8 : 0,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            overflow: 'hidden',
            gap: '4px 17px',
            flex: 1,
            ...titleCss,
          })}
        >
          <div css={{ paddingRight: paddingRightTitle }}>{title}</div>
          {!collapsed && (
            <TitleChildrenWrapper>
              {fieldAssetPicker}
              <DropdownSettingsButton options={titleLink} desktopOutsideMobileDropdownOptions={titleToggle} />
            </TitleChildrenWrapper>
          )}
        </div>
      </div>
    </div>
  )
}
